export enum GridColumnState {
  VISIBLE,
  HIDDEN
}
